import { render, staticRenderFns } from "./headeresa.vue?vue&type=template&id=56bf74a5&scoped=true"
import script from "./headeresa.vue?vue&type=script&lang=js"
export * from "./headeresa.vue?vue&type=script&lang=js"
import style0 from "./headeresa.vue?vue&type=style&index=0&id=56bf74a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf74a5",
  null
  
)

export default component.exports